import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './accolades-list-v2.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
var AccoladesListV2 = /** @class */ (function (_super) {
    tslib_1.__extends(AccoladesListV2, _super);
    function AccoladesListV2(element) {
        return _super.call(this, element) || this;
    }
    AccoladesListV2.prototype.init = function () {
        this.carouselContainer = this.element.querySelector('.accolades-list-v2__carousel--swiper');
        this.carouselPagination = this.element.querySelector('.slider__pagination');
        this.carousel = new Swiper(this.carouselContainer, {
            slidesPerView: 3,
            centeredSlides: false,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: {
                1024: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                580: {
                    initialSlide: 0,
                    slidesPerView: 1,
                    spaceBetween: 10,
                }
            },
            freeMode: false,
            pagination: {
                el: this.carouselPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: '.slider__nav--next',
                prevEl: '.slider__nav--prev',
            }
        });
    };
    AccoladesListV2.prototype.bindEvents = function () {
    };
    return AccoladesListV2;
}(Base));
export { AccoladesListV2 };



//////////////////
// WEBPACK FOOTER
// ./components/accolades-list-v2/accolades-list-v2.component.ts
// module id = 764
// module chunks = 0